import create from "zustand";

export const useStore = create((set, get) => ({
  myCourseNavSelection: {
    university: "",
    courses: [],
  },
  sCourseNavSelectedUni: { name: "" },
  ScourseNavQueryFilter: { name: "" },
  ScourseNavSearchText: "",
  startChat: {
    toggleChat: false,
    type: null,
    chatTitle: null,
    receiverId: null,
    chatId: null,
    profilePicture: null,
    unreadMessagesCount: null,
  },
  menuIsOpen: false,
  
  // Course navigation state
  isMyCoursesOpen: false,
  isSearchCoursesOpen: false,

  // Menu state management
  setMenuIsOpen: (isOpen) => set({ menuIsOpen: isOpen }),
  
  // Course navigation state management
  setIsMyCoursesOpen: (isOpen) => set({ isMyCoursesOpen: isOpen }),
  setIsSearchCoursesOpen: (isOpen) => set({ isSearchCoursesOpen: isOpen }),
}));
